import Super from 'client-portal/routes/-request/information/index';
import classic from 'ember-classic-decorator';

@classic
export default class SiteRequestInformationIndex extends Super {}
